import { PitchDeckLandingSection } from '@src/components/sco/PitchDeck/sections/PitchDeckLandingSection'
import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'

export { getServerSideProps } from '@src/lib/server-side-rendering.tsx'

export default function Page() {
  const activeContent = useActiveContentContext()

  // Page-level SEO so title/description are present even if the section is delayed.
  useUniversalEffect(() => {
    activeContent.setSiteSection('pitch-decks.landing')
    activeContent.setItem({
      __typename: 'LandingPage',
      title: 'Pitch Decks. Funded.',
      description:
        'Stop guessing. Get an investor-grade audit of your pitch deck — scores, objections, and rewrites for the slides that cost you meetings.',
    })
    return () => activeContent.setItem(null)
  }, [])

  return <PitchDeckLandingSection />
}
